import { newsItems } from "@/content/news";
import { SectionHeader } from "@/components/common/SectionHeader";
import { ButtonLink } from "@/components/common/ButtonLink";
import { Reveal } from "@/components/motion/Reveal";
import { NewsCard } from "./NewsCard";

// Home page strip: the three most recent news items.
export const LatestNews = () => (
  <section className="section-y border-t border-line" data-testid="latest-news">
    <div className="container-x">
      <div className="mb-14 flex flex-col gap-8 sm:flex-row sm:items-end sm:justify-between">
        <SectionHeader eyebrow="News" title="Latest news" />
        <Reveal>
          <ButtonLink to="/news" variant="ghost" testId="view-all-news-button">
            View all news
          </ButtonLink>
        </Reveal>
      </div>
      <Reveal className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {newsItems.slice(0, 3).map((n) => (
          <NewsCard key={n.id} n={n} variant="card" />
        ))}
      </Reveal>
    </div>
  </section>
);
